// ============================================================
// USPATIH GO — Alpine Store: Wishlist
// ============================================================

import Alpine from 'alpinejs';
import axios from '../config/axios.js';

Alpine.store('wishlist', {
  productIds: [],
  loadingIds: false,
  togglingId: null,

  has(productId) {
    if (!productId) return false;
    return this.productIds.includes(productId);
  },

  async syncIds() {
    const token = localStorage.getItem('uspatih_token');
    if (!token) {
      this.productIds = [];
      return;
    }

    this.loadingIds = true;
    try {
      const { data } = await axios.get('/api/v1/wishlist/ids');
      this.productIds = data.data?.product_ids || [];
    } catch {
      // abaikan jika belum login / token expired
    } finally {
      this.loadingIds = false;
    }
  },

  async toggle(productId) {
    if (!productId) return false;

    const store = Alpine.store('auth');
    if (!store?.isLoggedIn) {
      const redirect = window.location.pathname + window.location.search;
      window.location.href = `/login?redirect=${encodeURIComponent(redirect)}`;
      return false;
    }

    this.togglingId = productId;
    try {
      const { data } = await axios.post('/api/v1/wishlist/toggle', { product_id: productId });
      const wishlisted = !!data.data?.wishlisted;

      if (wishlisted) {
        if (!this.productIds.includes(productId)) {
          this.productIds = [...this.productIds, productId];
        }
        window.toast?.(data.message || 'Produk ditambahkan ke wishlist.', 'success');
      } else {
        this.productIds = this.productIds.filter((id) => id !== productId);
        window.toast?.(data.message || 'Produk dihapus dari wishlist.', 'success');
      }

      return wishlisted;
    } catch (e) {
      window.toast?.(e.response?.data?.message || 'Gagal mengubah wishlist.', 'error');
      return null;
    } finally {
      this.togglingId = null;
    }
  },
});

document.addEventListener('alpine:init', () => {
  Alpine.store('wishlist').syncIds();
});
